import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ConfigService} from './config.service';
import {CreditOptions} from '../model/eligibility-check/credit-options.model';
import {CreditAssessment} from '../model/eligibility-check/credit-assessment.model';
import {Option} from '../borrow/eligibility-check/options/option-row/option';
import {ManualCreditAssessment} from '../model/manual-credit-assessment.model';
import {PreApprovedLoanManualCreditAssessment} from '../model/eligibility-check/pre-approved-loan-manual-credit-assessment.model';

@Injectable()
export class CreditAssessmentService {
    constructor(private httpClient: HttpClient, private configService: ConfigService) {
    }

    public async getOptionsByAssessmentId(creditAssessmentId: string): Promise<CreditOptions> {
        const url = `${this.configService.getCreditAssessmentServiceUrl()}/credit-options`;
        const httpParams = new HttpParams().set('creditAssessmentId', creditAssessmentId);

        return await this.httpClient.get<CreditOptions>(url, {params: httpParams}).toPromise();
    }

    public async getCreditOptionById(creditOptionId: string): Promise<Option> {
        const url = `${this.configService.getCreditAssessmentServiceUrl()}/credit-option/${creditOptionId}`;
        return await this.httpClient.get<Option>(url).toPromise();
    }

    public async getAssessmentByCreditOptionId(creditOptionId: string): Promise<CreditAssessment> {
        const url = `${this.configService.getCreditAssessmentServiceUrl()}/credit-assessment`;
        const httpParams = new HttpParams().set('creditOptionId', creditOptionId);

        return CreditAssessment.from(await this.httpClient.get(url, {params: httpParams}).toPromise());
    }

    public async getManualCreditAssessmentByLoanApplicationId(loanApplicationId: string): Promise<ManualCreditAssessment> {
        const url = `${(this.configService.getCreditAssessmentServiceUrl())}/manual-credit-assessment?loanApplicationId=${loanApplicationId}`;
        return await this.httpClient.get<ManualCreditAssessment>(url).toPromise();
    }

    public async getPreApprovedLoanOffersForUser(userId: string, all: boolean): Promise<PreApprovedLoanManualCreditAssessment[]> {
        const url = !all ?  `${(this.configService.getCreditAssessmentServiceUrl())}/pre-approved-loan-manual-credit-assessments?userId=${userId}` :
            `${(this.configService.getCreditAssessmentServiceUrl())}/pre-approved-loan-manual-credit-assessments?userId=${userId}&all=${all}`;
        const preApprovedLoanOffers = await this.httpClient.get<PreApprovedLoanManualCreditAssessment[]>(url).toPromise();
        return preApprovedLoanOffers ? preApprovedLoanOffers.map(offer => PreApprovedLoanManualCreditAssessment.from(offer)) : null;
    }

    public async availPreApprovedLoanOffer(id: string, preApprovedLoanOfferRequest: { loanApplicationId: string }): Promise<void> {
        const url = `${(this.configService.getCreditAssessmentServiceUrl())}/pre-approved-loan-manual-credit-assessments/${id}/avail`;
        return await this.httpClient.post<void>(url, preApprovedLoanOfferRequest).toPromise();
    }

    public async getIndicativeLoanOffer(body: { creditReportId: string, monthlyIncome: number }): Promise<any> {
        const url = `${(this.configService.getCreditAssessmentServiceUrl())}/credit-assessment/indicative-loan-offer`;
        return await this.httpClient.post<any>(url, body).toPromise();
    }
}
